module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f7Rv9"))).then(() => module.bundle.root('iDabs'));